module.exports = __webpack_public_path__ + "static/img/IMG_20240326_190232.c046fb02.jpg";